<mat-form-field fxFlex="100" appearance="outline" [subscriptSizing]="subscriptSizing">
    <mat-label>{{ placeholder }}</mat-label>
    <mat-select #select disableRipple [compareWith]="compareFn" [(ngModel)]="selectedValue" [required]="required"
        [disabled]="disabledPick">
        <mat-select-trigger class="input-group" fxLayoutAlign="space-between center">
            <div fxFlex="80" *ngIf="value">
                <ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ content: value }">
                </ng-template>
            </div>
            <div class="input-group__action" fxFlex="26px">
                <button mat-icon-button type="button" (click)="deselectObject($event)" [disabled]="disabled"
                    [style.padding]="'0px'">
                    <mat-icon svgIcon="close"></mat-icon>
                </button>
            </div>
        </mat-select-trigger>

        <mat-option class="input-field">
            <syn-picker-input [translations]="translations" (load)="load($event)" />
        </mat-option>

        <mat-option *ngIf="fetching && !filteredResults.length" class="disable-blur">
            <div class="option__title">{{ translations?.CONTENT?.LOADING || 'Chargement' }}</div>
        </mat-option>

        <mat-option *ngIf="newItemTemplate && !fetching" (onSelectionChange)="onCreateObject($event)"
            class="disable-blur">
            <ng-template [ngTemplateOutlet]="newItemTemplate"></ng-template>
        </mat-option>

        <mat-option *ngIf="!filteredResults.length && !fetching" class="disable-blur">
            <mat-icon svgIcon="cancel"></mat-icon>
            {{ translations?.CONTENT?.EMPTY_RESULTS || 'Aucun résultat' }}
        </mat-option>

        <mat-option *ngFor="let result of filteredResults | slice:0:show;" [value]="result" class="disable-blur">
            <ng-template [ngTemplateOutlet]="itemTemplate"
                [ngTemplateOutletContext]="{ content: result }"></ng-template>
        </mat-option>

        <mat-option *ngIf="latterTemplate && !fetching" class="disable-blur">
            <ng-template [ngTemplateOutlet]="latterTemplate"></ng-template>
        </mat-option>

        <div *ngIf="fetching" class="options-overlay">
            <mat-spinner [diameter]="32" color="accent"></mat-spinner>
        </div>

        <div fxLayout="row" fxLayoutAlign="center center">
            <button mat-button color="primary" (click)="toggleLoader()"
                *ngIf="!loadMore && show < filteredResults.length || show > filteredResults.length"
                [disabled]="disabledPick" fxLayoutAlign="center center" synFocus>
                <mat-icon svgIcon="plus"></mat-icon>Charger plus d'élèments
            </button>
        </div>

    </mat-select>

    <mat-error *ngIf="errorMessage">{{ errorMessage }}</mat-error>
</mat-form-field>
